export default __webpack_public_path__ + "static/media/cow_portrait.240ce378.jpg";